<template>
  <v-form v-model="valid" ref="form">
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field label="Description on purchase forms" v-model="item.buyingDescription" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
        </v-col>
      </v-row>
      <v-row dense v-if="values && connectedToAccounting && item.type!='Item'">
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="item.cogAccountRef" label="Expense account"
                          :accounts="accounts" :addTypes="['Expense']"
                          hint="The expense account is used to track purchases of this item"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="3" md="2">
          <v-text-field label="Buying units" v-model="item.buyingUnits" :rules="[fieldRules.maxLength(10)]" :counter="10" outlined dense
                        hint="The units used to purchase this item"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-select label="Decimal places" v-model="item.buyingPrecision" :items="[0,1,2,3]" outlined dense hint="for quantities"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input label="Convert to tracking" v-model="item.convertToTracking" prefix="" suffix="" :precision="3" :min="0.001"
                                hint="The factor to multiply buying units to convert to tracking units"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="3" md="2" v-if="item.type==='Item'">
          <decimal-number-input label="Reorder point" v-model="item.reorderPoint" prefix="" :suffix="item.trackUnits" :precision="item.precision" no-minimum
                                hint="Reordering should occur if inventory is at this point"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input label="Default reorder quantity" v-model="item.reorderQuantity" prefix="" :suffix="item.buyingUnits" :precision="item.precision"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input label="Reorder lead time" v-model="item.reorderDays" prefix="" suffix="days" :precision="0"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-checkbox label="Business days" v-model="item.reorderBusinessDays" hide-details class="mt-1"/>
        </v-col>
      </v-row>
      <v-row dense v-if="vendors.length>0">
        <v-col cols="12" sm="6" md="4">
          <v-autocomplete outlined dense hide-details clearable label="Preferred supplier" v-model="item.preferredVendorId" :items="vendors" item-value="id" item-text="name"/>
        </v-col>
      </v-row>
      <v-row class="mt-6">
        <v-col cols="12" md="10" lg="8">
          <supplier-costing :vendors="item.vendors" :allVendors="vendors" :taxes="taxes" :default-sku="item.sku"/>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import SupplierCosting from '@/components/SupplierCosting'

export default {
  name: 'InventoryItemsEditBuying',
  components: {SupplierCosting},
  props: {
    item: {type:Object, required:true},
    taxes: {type:Array, required:true},
    accounts: {type:Array, required:true},
    values: {type:Boolean, required:true}
  },
  data() {
    return {
      valid: true,
      vendors: [],
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    },
    expenseAccounts() {
      return this.accounts.filter(account => account.type === 'Expense');
    },
  },
  async created() {
    if (this.$store.getters.company.permissions.includes('buying'))
      this.$lazyListLoad(this.vendors, 'vendors2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
  }
}
</script>